import React from 'react';
import { ObjectWrapper } from './styles/Common.styles';
import { ListWrapper, ListItem } from './styles/List.styles';

const ListControl = ({ control }) => (
  <ObjectWrapper>
    <ListWrapper styleProps={control.attributes}>
      {control.items.map(item => (
        <ListItem
          key={item.value}
          isSelected={item.isSelected}
          styleProps={control.attributes}
        >
          {item.caption}
        </ListItem>
      ))}
    </ListWrapper>
  </ObjectWrapper>
);

export default ListControl;